const DEFAULT_CONFIG = {
  //标题
  APP_NAME: process.env.VUE_APP_TITLE,

  //首页地址
  DASHBOARD_URL: '/oms/dashboard',
  //接口地址
  // API_URL: process.env.NODE_ENV === 'development' && process.env.VUE_APP_PROXY === 'true' ? "/api" : process.env.VUE_APP_API_BASEURL,

  //请求超时
  TIMEOUT: 600000,

  //TokenName
  TOKEN_NAME: 'Authorization',

  //Token前缀，注意最后有个空格，如不需要需设置空字符串
  TOKEN_PREFIX: 'Bearer ',

  //追加其他头
  HEADERS: {},

  //菜单是否启用手风琴效果
  MENU_UNIQUE_OPENED: true,
}
export default DEFAULT_CONFIG
